<article
    class="relative"
    [attr.id]="componentId"
    [ngClass]="{
        'h-44': size() === 'regular',
        'h-40': size() === 'small',
        'w-172': isLg() && closedInputSize() === '172',
        'w-250': isLg() && closedInputSize() === '250',
        'w-420': isLg() && closedInputSize() === '420',
    }"
    (focusout)="checkTargetAndClose($event)"
>
    <section
        class="absolute flex flex-col"
        [ngClass]="{
            'z-10 rounded-3xl shadow-sm ring-2 ring-border-focus':
                isInputFocused(),
            'right-0': openLeft(),
            'w-172': isMd() && !isInputFocused() && closedInputSize() === '172',
            'w-250': isMd() && !isInputFocused() && closedInputSize() === '250',
            'w-420': isMd() && !isInputFocused() && closedInputSize() === '420',
        }"
    >
        <div
            class="flex items-center justify-between rounded-3xl transition duration-250"
            [ngClass]="{
                'py-2': size() === 'regular',
                'py-4': size() === 'small',
                'px-12': !isInputFocused(),
                'w-340 rounded-b-none px-16 lg:w-420': isInputFocused(),
                'bg-surface-A': bgColor() === 'surface-A',
                'bg-surface-B': bgColor() === 'surface-B',
            }"
        >
            <label class="sr-only" for="advanced-search-input">{{
                'SHARED.SEARCH.TITLE' | translate
            }}</label>
            @if (isMd() || isInputFocused() || search.value) {
                <input
                    #searchInput
                    autocomplete="off"
                    class="min-w-0 grow bg-transparent typo-sm"
                    data-testid="advanced-search-bar-input"
                    id="advanced-search-input"
                    type="text"
                    [formControl]="search"
                    [ngClass]="{
                        'h-20': isInputFocused(),
                    }"
                    [placeholder]="placeholder() | translate"
                    (focus)="openSearch()"
                />
            }
            @if (search.value) {
                <button
                    class="shrink-0"
                    interacta-icon-button
                    type="button"
                    [icon]="'close'"
                    [label]="'UI.SEARCH.INPUT_CLEAR' | translate"
                    [size]="size() === 'regular' ? 'regular' : 'small'"
                    [style]="'text'"
                    (click)="search.reset()"
                ></button>
            }
            <button
                class="text-text-primary"
                interacta-icon-button
                type="submit"
                [icon]="'search-left'"
                [label]="'UI.BUTTON.SEARCH' | translate"
                [size]="size() === 'regular' ? 'regular' : 'small'"
                (click)="openSearch(true)"
            ></button>
        </div>

        @if (isInputFocused()) {
            <div
                class="flex w-full flex-col rounded-b-3xl bg-surface-A px-16 pb-16 typo-sm"
            >
                <interacta-separator [thickness]="'soft'" />
                <ng-content select="[advanced-search]" />
            </div>
        }
    </section>
</article>
